import { Component, Injectable, OnInit } from '@angular/core';
import {
    ActivatedRoute,
    ActivatedRouteSnapshot,
    Resolve,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { ImageRequests } from 'src/app/model/imageRequest/imageRequest';
import { DialogService } from 'src/app/service/dialog-service';
import { WebDataApiService } from 'src/app/service/server/web-data-api-service';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { RouterService } from 'src/app/service/router-service';
import { HttpHelper } from 'src/app/utils/http-helper';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EndpointConfig } from 'src/app/config/endpoint-config';

type ResolverResult = {
    requests: any[];
    total: number;
}

@Injectable()
export class ImageRequestDetailResolver implements Resolve<ImageRequests> {

    constructor(
        private webDataApiService: WebDataApiService,
        private dialog: DialogService,
        private endpointConfig: EndpointConfig,
        private http: HttpClient) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

        this.dialog.loadingShow()
        var requestId = route.paramMap.get('id')
        console.log(requestId)
        const paramsObj: any = {
            id: String(requestId)
        };

        return this.getImageReq(paramsObj).pipe(
            finalize(() => this.dialog.loadingHide())
        )
    }
    getImageReq(paramsObj: { [key: string]: string }): Observable<ImageRequests> {
        var url = this.endpointConfig.riaApi.imageRequests.getUrl()
        const params = new HttpParams({ fromObject: paramsObj })
        return this.http.get<ImageRequests>(url, { params })
    }
}



@Component({
    selector: 'tag-image-request-detail',
    templateUrl: './image-request-detail.component.html',
    styleUrls: ['./image-request-detail.component.css'],
})
export class ImageRequestDetailComponent implements OnInit {
    request: any | null = null;
    total = 0;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private routerService: RouterService,
        private httpHelper: HttpHelper
    ) {
    }
    ngOnInit(): void {
        this.activatedRoute.data.subscribe(d => {
            const resolved = d['request'] as ResolverResult;
            this.total = resolved.total;
            this.request = resolved.requests[0];

            console.log('resolved', resolved);
            console.log('request', this.request);
        })
    }

    back() {
        if (this.routerService.getCurrentUrl() === this.routerService.getPreviousUrl()) {
            this.router.navigate(['tag/home'])
        } else {
            this.router.navigateByUrl(this.routerService.getPreviousUrl())
        }
    }
}

